import React from 'react';
import { Image } from 'chic-ui';
import { Row } from 'react-bootstrap';

const Src = () => {
  return (
    <>
      <h4 className="mt-5">Examples</h4>
      <p>
       Images can be displayed using the <i>src</i> prop.
      </p>
      <p>Note: To change the dimensions of the image, use the <i>width</i> and <i>height</i> props. By default the width and height of the image is 100%</p>
      <div className="btn-group btns mt-3">
        <Image className="single-btn" src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSZNO3U161Gmfn4tpmvDt3j-5wQlY4CsKulAw&usqp=CAU' width='160px' height='130px' />
        <Image className="single-btn" src='https://wallpaperaccess.com/full/32048.jpg' width='160px' height='130px' />
      </div>
      <Row className="mt-3" fluid>
        <code>
          {'import { Image } from "chic-ui";'}
          <br />
          {'<Image src="cat1.png" width="160px" height="130px" />'}
          <br />
          {'<Image src="cat2.png" width="160px" height="130px" />'}
          <br />
        </code>
      </Row>
    </>
  );
};

export default Src;
